<template>
	<o-select
		v-model="setup.groups"
		:label="$t('business.settings.agency.contract.pool')"
		track-key="id"
		display-key="label"
		:options="setup.groupOptions"
		multiple
		@add="setup.addGroupAsync($event)"
		@remove="setup.removeGroupAsync($event)"/>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedOrderGroupSelectEmits, SharedOrderGroupSelectProps } from './SharedOrderGroupSelectSetup';
import SharedOrderGroupSelectSetup from './SharedOrderGroupSelectSetup';
const emits = defineEmits<SharedOrderGroupSelectEmits>() as SharedOrderGroupSelectEmits;
const props = withDefaults(defineProps<SharedOrderGroupSelectProps>(), SharedOrderGroupSelectSetup.defaultProps);
const setup = new SharedOrderGroupSelectSetup(props, emits);
// #endregion
</script>
